/** OpenAPI 3.1 skeleton. Each module appends its paths as it is built. */
export const openApiDocument = {
  openapi: '3.1.0',
  info: {
    title: 'Roovers Business Suite API',
    version: '0.0.1',
    description:
      'REST API for the Roovers Business Suite. Client-agnostic: web, PWA and future native app.',
  },
  servers: [{ url: '/api/v1' }],
  paths: {
    '/health': {
      get: {
        summary: 'Service and database health',
        tags: ['System'],
        responses: {
          '200': {
            description: 'Healthy',
            content: { 'application/json': { schema: { $ref: '#/components/schemas/Health' } } },
          },
          '503': {
            description: 'Database unavailable',
            content: { 'application/json': { schema: { $ref: '#/components/schemas/Health' } } },
          },
        },
      },
    },
  },
  components: {
    schemas: {
      Health: {
        type: 'object',
        required: ['status', 'database', 'time'],
        properties: {
          status: { type: 'string', enum: ['ok', 'degraded'] },
          database: { type: 'string', enum: ['up', 'down'] },
          time: { type: 'string', format: 'date-time' },
          version: { type: 'string' },
        },
      },
    },
  },
} as const;
